import React from 'react';

export default function MyPage() {
  return <div>My page</div>;
}
